<div class="support-chat--wrapper" *ngIf="!_main.global_bar">
  <div class="container-fluid">
    <div class="row m-3">
      <div class="col-md-2 border-right p-0">
        <div class="support-chat--left pt-4">
          <h4 class="recent-chat-heading">
            Recent Chats
            <i style="font-size: 14px" (click)="recentChat()" class="fa m-1">&#xf021;</i>
          </h4>
          <ng-container>
            <div class="recent-chat-card d-flex gap-3" *ngFor="let chatType of chatTypeArray"
              (click)="updatePanel(chatType)"
              [class.activeCard2]="chatType.panel_type === this._socketService.panel_type && !assigned_id">
              <div class="content-middle">
                <div class="top d-flex justify-content-between">
                  <h4 class="user-name gap-2 d-flex align-items-center justify-content-between">
                    <img [src]="chatType?.icon"><span>{{ chatType.text }}</span>
                  </h4>
                  <!-- <p class="message d-flex align-items-center justify-content-between">
                      <span class="unread-message">{{ chatType.new_msg_count }}</span>
                    </p> -->
                </div>
              </div>
            </div>


            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="true" aria-controls="collapseOne">
                    <img src="assets/images/chatbot/Users_Group.png">
                    Active Teammates
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <div class="list" *ngFor="let dt of this.unreadData && this.unreadData.teammates" (click)="this.assigned_id = dt.admin_id ;
                      this.selected_admin_name = dt.admin_name; recentChat()"
                      [class.activeCard]="this.selected_admin_name == dt.admin_name">
                      <span>{{dt.admin_name}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-md-10 border-right p-0">
        <div #scrollContainer class="support-chat--left pt-4 chat" [infiniteScrollContainer]="scrollContainer"
          [infiniteScrollDistance]="1" [infiniteScrollThrottle]="10" [scrollWindow]="false" infiniteScroll
          (scrolled)="onScrollDown()">
          <div class="chat--header">
            <h4>
              <img src="assets/images/chatbot/your-inbox-icon.svg" class="mr-2"> <span>{{this.current_chat_type}}
                {{selected_admin_name != '' ?
                '('+ selected_admin_name + ')' : ''}}</span>
              <!-- <div class="col-7" *ngIf="chat_type !== 5">
                <span class="text-center  blinking-text text-danger"  style="font-size:20px;text-decoration: underline;"  (click)=" this.chat_type !== 2 && updateChats(chatTypeArray[1])" *ngIf="chatTypeArray[1].new_msg_count > 0"> You have {{chatTypeArray[1].new_msg_count}} Unassigned Chats </span>
              </div> -->
            </h4>
          </div>
          <div class="inbox-read-unread-card ml-2 d-flex justify-content-between mx-3">
            <!-- <div class="left d-flex align-items-center gap-2" *ngIf="this.chat_type != 5">
                <p class="chats read--chat" [ngClass]="{ 'active--chat': !readChatShow }" (click)="readUnread(1)">
                  All
                </p>
                <p class="chats unread-chat" [ngClass]="{ 'active--chat': readChatShow }" (click)="readUnread(2)">
                  Unread
                  <span class="unread-count">{{unreadData?.unReadMsgCount || 0}}</span>
                </p>
              </div> -->

            <div class="left d-flex align-items-center gap-2">
              <p class="chats read--chat" [ngClass]="{ 'active--chat': this.chat_type == 1 }" (click)="updateChats(1)">
                All Chats
              </p>
              <p class="chats unread-chat" [ngClass]="{ 'active--chat': this.chat_type == 2 }" (click)="updateChats(2)">
                Unassigned Chats
                <!-- <span class="unread-count">{{unreadData?.unReadMsgCount || 0}}</span> -->
              </p>
              <p class="chats unread-chat" [ngClass]="{ 'active--chat': this.chat_type == 3 }" (click)="updateChats(3)">
                Your Inbox
                <!-- <span class="unread-count">{{unreadData?.unReadMsgCount || 0}}</span> -->
              </p>
            </div>

            <div class="right d-flex gap-3 align-items-center">
              <div class="search_div my-3">
                <div class="input">
                  <img src="assets/images/search-Icon.png" alt="secrch">
                  <input type="text" placeholder="Search" [(ngModel)]="search" (keyup.enter)="recentChat()" />
                  <i class="fa fa-close" *ngIf="search != ''" (click)="search = ''; recentChat()"></i>
                </div>
              </div>
              <div class="mx-3 cursor" (click)="show_filters.show()">
                <span class="filter_count"
                  *ngIf="this.selected_filter.length > 0">{{this.selected_filter.length}}</span>
                <img src="assets/images/chatbot/chat-filter.svg"> <span></span>
                <!-- <button class="btn btn-outline-dark mr-3" (click)="show_filters.show()">
                  </button> -->

              </div>
            </div>
          </div>
          <div class="d-flex gap-3 justify-content-between mx-3 align-items-baseline mb-3"
            *ngIf="selected_filter.length > 0">
            <div class="d-flex gap-3 align-items-center">
              <div class="filter-applybtn" *ngFor="let dt of selected_filter">
                <span>{{dt.value}}</span>
                <button type="button" class="btn-close" (click)="remove_filter(dt)"></button>
              </div>
            </div>
            <div class="reset--button">
              <p (click)="reset_filter()">
                Clear All Filters
              </p>
            </div>
          </div>
          <div class="user__tabel">
            <div class="tableData" style="border: none !important; overflow: unset !important;">
              <table *ngIf="
                  recentchatData && recentchatData.length > 0;
                  else noChatList
                " class="w-100 table support-chat-dataTable">
                <thead>
                  <th>User</th>
                  <!-- <th>User Type</th> -->
                  <th>Status</th>
                  <th>Assignee</th>
                  <th>Last Message</th>
                  <th>Last Message From</th>
                  <!-- <th>Priority</th> -->
                  <th>User Last Update</th>
                  <th>Admin Last Update</th>
                </thead>
                <tbody>
                  <tr *ngFor="let recentData of recentchatData"
                    [class.activeCard]="recentData.user_id === activeUserId">
                    <td class="user-name">
                      <div class="image" style="position:relative">
                        <!-- <img src="assets/images/chatbot/chat-profile-avtar.svg" (click)="recentStats(recentData,1)" style="cursor: pointer;" /> -->

                        <div class="avatar" (click)="recentStats(recentData,1)">
                          <span id="initials" style="position: absolute;"
                            *ngIf="getInitials(recentData.name) != 'RC'">{{ getInitials(recentData.name) }}</span>
                          <img style="position: absolute; height: 35px; width: 35px;"
                            *ngIf="getInitials(recentData.name) == 'RC'" class="col_img"
                            src="https://common.coolcredit.com/web-panel/profile-placeholder.png" alt="">
                        </div>
                        <p class="gap-2">
                          <!-- <span class="user_name" (click)="recentStats(recentData,1)" style="cursor: pointer;"> {{ recentData.name ? recentData.name : "Recuvery User" }}</span> -->
                          <span class="user--id" (click)="redirectV2(recentData.user_id,1)"> {{ recentData.name ?
                            recentData.name : "Recuvery User" }}{{ recentData.user_id && '(' +recentData.user_id +
                            ')'}}</span>
                          <span class="user--id" (click)="redirectV2(recentData.req_id,2)">Ticket</span>
                          <span (click)="recentStats(recentData)"
                            style="cursor: pointer; color: #00995f;font-weight: 800;text-decoration: underline;margin-right: 5px;">Open
                            Chat</span>
                          <span *ngIf="isNewMessage(recentData.last_msg_time) &&  this.chat_type == 2"
                            class="badge bg-info">
                            New
                          </span>
                        </p>
                      </div>
                    </td>
                    <!-- <td class="user-type">
                        <p [ngStyle]="{'color': (recentData.sub_status !== null || recentData.booster_status !== null) ? '#E0990D' : ''}"> {{
                          (recentData.sub_status == 1 ||
                          recentData.sub_status == 2) &&
                          (recentData.booster_status == 0 || recentData.booster_status == null)
                          ? "Pro User"
                          : (recentData.sub_status == 1 ||
                          recentData.sub_status == 2) &&
                          recentData.booster_status == 1
                          ? "Pro User + Booster"
                          : (recentData.sub_status == null ||
                          !recentData.sub_status) &&
                          recentData.booster_status == 1
                          ? "Booster"
                          : "Free User"
                          }}</p>
                      </td> -->
                    <td class="user-status" [ngClass]="
                      recentData.ticket_status == 2 ? 'closed' : 'active'
                    ">
                      <p> {{ recentData.ticket_status == 2 ? "Closed" : "Active" }}</p>
                    </td>
                    <td class="user-admin-name">
                      <p>{{ recentData.admin_name ? recentData.admin_name : 'Not Assigned' }}</p>
                    </td>
                    <td class="user-note-description">
                      <p> {{ recentData.note ? recentData.note : '*New message' }}
                      </p>
                      <i class="fa fa-info mt-1 info-tooltip mx-2" [tooltip]="recentData.note"></i>
                      <span class="unread-message" *ngIf="recentData.new_msg_count > 0"></span>
                    </td>
                    <td class="user-last-msg">
                      <p> {{ recentData.last_msg_type == 1 ? "Admin" : 'User' }}</p>
                    </td>
                    <!-- <td class="user-priority" *ngIf="recentData.priority == 3">
                        <img src="assets/images/chatbot/selected.png" />
                      </td>
                      <td class="user-priority" *ngIf="recentData.priority !== 3">
                        <img src="assets/images/chatbot/unselected.png" />
                      </td> -->
                    <td class="user-waiting-msgTime">
                      <p> {{ recentData.msg_time }} </p>
                    </td>
                    <td class="user-last-update">
                      <p> {{ recentData.admin_last_msg_time }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <ng-template #noChatList>
          <p class="no-chat mt-5">No Chat List Found</p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
<!-- <div class="text-center nodata p-3" *ngIf="!recentchatData && !global_bar" >
    <i class="fa fa-exclamation-triangle fa-5x"> </i>
    <p>Chat Not Found</p>
  </div> -->

<div class="modal fade" #show_filters="bs-modal" class="modal fade modal-global--bg" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true" [config]="{ ignoreBackdropClick: true }" bsModal>
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content">
      <div class="modal-header" style="padding: 10px 1rem !important;">
        <p class="modal-title" id="exampleModalLabel">Filters</p>
        <button type="button" class="btn-close" (click)="show_filters.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="dropdown payment_status">
          <div class="form-group">
            <label class="fw-500 mb-1">Chat Status</label>
            <select [(ngModel)]="chat_status" class="form-select" name="chat_status" style="border-radius: 1px">
              <option value="1">All</option>
              <option value="2">Active-Reopen</option>
              <option value="3">Closed</option>
            </select>
          </div>
        </div>

        <div class="dropdown payment_status mt-3">
          <div class="form-group">
            <label class="fw-500 mb-1">User Status</label>
            <select [(ngModel)]="user_status_filter" class="form-select" name="user_status" style="border-radius: 1px">
              <option value="1">All</option>
              <option value="2">Online</option>
              <option value="3">Offline</option>
            </select>
          </div>
        </div>

        <div class="sub-heading mt-3 mb-1">Date Range</div>
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 pl-0">
            <div class="date -start">
              <div class="form-group">
                <input type="text" [(ngModel)]="start_date" class="form-control" bsDatepicker
                  [ngModelOptions]="{ standalone: true }" [bsConfig]="bsConfig" name="start_date"
                  placeholder="Start Date" />
                <i class="far fa-calendar-alt"></i>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 pl-0">
            <div class="date -end">
              <div class="form-group">
                <input type="text" [(ngModel)]="end_date" class="form-control" bsDatepicker
                  [ngModelOptions]="{ standalone: true }" [bsConfig]="bsConfig" name="end_date"
                  placeholder="End Date" />
                <i class="far fa-calendar-alt"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="model-footer mt-4">
          <button class="btn btn-success" (click)="this.filter_apply = true;this.offset = 0; recentChat()">
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #rightSideBar="bs-modal" [config]="{ ignoreBackdropClick: true }"
  class="modal fade right right--modal rightSideBar" id="exampleModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" style="background: none !important;">
  <div class="modal-dialog modal-dialog--modify modal-lg modal-dialog-centered" role="document">
    <div class="modal-content pathradius p-0 chat-support--modal">
      <div class="modal-header d-flex justify-content-between modal-header-backbtn p-0 chat--screen-close">
        <div class="back-btn">
          <a type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="rightSideBar.hide(); leaveAdmin()"></a>
        </div>
      </div>
      <div>
        <app-chat-support></app-chat-support>
      </div>
    </div>
  </div>

  <div bsModal #viewDocModal="bs-modal" [config]="{ ignoreBackdropClick: true }" class="modal fade expert-review--modal"
    id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content subscription view-document-modal view--document">
        <div class="modal-header">
          <p class="mb-0 great-news">Document</p>
          <img src="assets/images/chatbot/Close Circle.png" style="position: absolute; right: 20px; cursor: pointer"
            class="close-high" data-bs-dismiss="modal" aria-label="Close" (click)="viewDocModal.hide()" alt="" />
        </div>
        <div class="modal-body subscription-body">
          <img class="view-img w-100" [src]="doc_url" alt="" />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- GLOBAL CHAT -->
<div class="global_bar mt-5" *ngIf="_main.global_bar">
  <div class="image info-tooltip" [placement]="'left'" [tooltip]="recentData.name ? recentData.name : 'Recuvery User' "
    *ngFor="let recentData of yourInboxData.slice(0,5)">
    <!-- <img src="assets/images/chatbot/chat-profile-avtar.svg" (click)="recentStats(recentData,2)" style="cursor: pointer;" /> -->
    <div class="avatar" (click)="recentStats(recentData,3)">
      <span id="initials" style="position: absolute;" *ngIf="getInitials(recentData.name) != 'CC'">{{
        getInitials(recentData.name) }}</span>
      <img style="position: absolute; height: 35px; width: 35px;" *ngIf="getInitials(recentData.name) == 'CC'"
        class="col_img" src="https://common.coolcredit.com/web-panel/profile-placeholder.png" alt="">
      <span class="unread-message" *ngIf="recentData.new_msg_count > 0">{{recentData.new_msg_count}}</span>
    </div>
  </div>
  <a class="view_all" (click)="updateChatsGlobal({text: 'Your inbox', chat_type: 3})"
    *ngIf="(yourInboxData ?? []).length > 0">View All</a>
  <div class="recent-chat-card d-flex gap-3 mt-3" *ngFor="let chatType of chatTypeArray"
    (click)="updateChatsGlobal(chatType)" [class.activeCard2]="chatType.chat_type === chat_type && !assigned_id">
    <div class="content-middle" style="border-bottom: 1px solid #D9D9D9;">
      <div class="top d-flex justify-content-between">
        <h4 class="user-name gap-2 d-flex align-items-center justify-content-between">
          <span class="unread-message-new" *ngIf="chatType.new_msg_count > 0">{{chatType.new_msg_count}}</span>
          <img class="info-tooltip" [tooltip]="chatType.text" [placement]="'left'" [src]="chatType?.icon"
            [ngStyle]="{'position': chatType.new_msg_count > 0 ? 'absolute' : 'static'}" />
        </h4>
      </div>
    </div>
  </div>
  <!-- <div style="position: absolute; bottom: 15px;">
    <img src="assets/images/chatbot/Scale.png" (click)="redirectV2(null,4);" />
  </div> -->
</div>

<div bsModal #globalRightSidebar="bs-modal" [config]="{ ignoreBackdropClick: false }"
  class="modal fade right right--modal-global globalRightSidebar" id="exampleModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" style="background: unset !important;">
  <div class="modal-dialog modal-dialog--modify modal-lg modal-dialog-centered" role="document">
    <div class="modal-content pathradius p-0 chat-support--modal">
      <div class="modal-header d-flex justify-content-between modal-header-backbtn p-0 chat--screen-close">
        <div class="back-btn">
          <a type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="globalRightSidebar.hide();leaveAdmin();"></a>
        </div>
      </div>
      <div>
        <app-chat-support></app-chat-support>
      </div>
    </div>
  </div>
</div>

<div bsModal #globalChatListing="bs-modal" [config]="{ ignoreBackdropClick: false }"
  class="modal fade right right--modal-global globalChatListing" id="exampleModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true"
  style="background: unset !important; overflow-y: hidden!important;">
  <div class="modal-dialog modal-dialog--modify modal-lg modal-dialog-centered" role="document">
    <div class="modal-content pathradius p-0 chat-support--modal">
      <div class="modal-header d-flex justify-content-between modal-header-backbtn p-0 chat--screen-close">
        <div class="back-btn">
          <a type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="globalChatListing.hide(); leaveAdmin();"></a>
        </div>
      </div>
      <div>
        <div class="border-right p-0">
          <div #scrollContainer class="support-chat pt-4 chat" [infiniteScrollContainer]="scrollContainer"
            [infiniteScrollDistance]="1" [infiniteScrollThrottle]="10" [scrollWindow]="false" infiniteScroll
            (scrolled)="onScrollDown()">
            <div class="chat--header">
              <h4> <img src="assets/images/chatbot/your-inbox-icon.svg"> <span>{{this.current_chat_type}}
                  {{selected_admin_name != '' ?
                  '('+ selected_admin_name + ')' : ''}}</span> </h4>
            </div>
            <div class="inbox-read-unread-card ml-2 d-flex justify-content-between">
              <!-- <div class="left d-flex align-items-center gap-2" *ngIf="this.chat_type !== 5">
                <p class="chats read--chat" [ngClass]="{ 'active--chat': !readChatShow }" (click)="readUnread(1)">
                  All
                </p>
                <p class="chats unread-chat" [ngClass]="{ 'active--chat': readChatShow }" (click)="readUnread(2)">
                  Unread
                  <span class="unread-count">{{unreadData?.unReadMsgCount || 0}}</span>
                </p>
              </div> -->

              <div class="right d-flex gap-3 align-items-center">
                <div class="search_div my-3">
                  <div class="input">
                    <img src="assets/images/search-Icon.png" alt="secrch">
                    <input type="text" placeholder="Search" [(ngModel)]="search" (keyup.enter)="recentChat()" />
                    <i class="fa fa-close" *ngIf="search != ''" (click)="search = ''; recentChat()"></i>
                  </div>
                </div>
                <div class="mx-3 cursor" (click)="show_filters_drop = !show_filters_drop;">
                  <span class="filter_count"
                    *ngIf="this.selected_filter.length > 0">{{this.selected_filter.length}}</span>
                  <img src="assets/images/chatbot/chat-filter.svg"> <span></span>
                  <!-- <button class="btn btn-outline-dark mr-3" (click)="show_filters_drop = !show_filters_drop;">
                  </button> -->

                </div>
              </div>
            </div>

            <div class="inbox-read-unread-card left d-flex align-items-center gap-2 ml-3 mx-3">
              <p class="chats chats--btn read--chat" [ngClass]="{ 'active--chat': chat_type == 1 || !chat_type  }"
                (click)="updateChats(1)">
                All Chats
              </p>
              <p class="chats chats--btn unread-chat" [ngClass]="{ 'active--chat': chat_type == 2 }"
                (click)="updateChats(2)">
                Unassigned Chats
                <!-- <span class="unread-count">{{unreadData?.unReadMsgCount || 0}}</span> -->
              </p>
              <p class="chats chats--btn unread-chat" [ngClass]="{ 'active--chat': chat_type == 3 }"
                (click)="updateChats(3)">
                Your Inbox
                <!-- <span class="unread-count">{{unreadData?.unReadMsgCount || 0}}</span> -->
              </p>
            </div>

            <div class="d-flex gap-3 justify-content-between mx-3 align-items-baseline mb-3"
              *ngIf="selected_filter.length > 0">
              <div class="d-flex gap-3 align-items-center">
                <div class="filter-applybtn" *ngFor="let dt of selected_filter">
                  <span>{{dt.value}}</span>
                  <button type="button" class="btn-close" (click)="remove_filter(dt)"></button>
                </div>
              </div>
              <div class="reset--button">
                <p (click)="reset_filter()">
                  Clear All Filters
                </p>
              </div>
            </div>
            <hr />
            <div class="modal-body" *ngIf="show_filters_drop">
              <div class="d-flex justify-content-between row">
                <div class="dropdown payment_status col-md-4 mb-3">
                  <div class="form-group">
                    <label class="fw-500">Chat Status</label>
                    <select [(ngModel)]="chat_status" class="form-select" name="chat_status" style="border-radius: 1px">
                      <option value="1">All</option>
                      <option value="2">Active-Reopen</option>
                      <option value="3">Closed</option>
                    </select>
                  </div>
                </div>

                <div class="dropdown payment_status col-md-4 mb-3">
                  <div class="form-group">
                    <label class="fw-500">User Status</label>
                    <select [(ngModel)]="user_status_filter" class="form-select" name="user_status"
                      style="border-radius: 1px">
                      <option value="1">All</option>
                      <option value="2">Online</option>
                      <option value="3">Offline</option>
                    </select>
                  </div>
                </div>

                <div class="dropdown payment_status col-md-4 mb-3">
                  <div class="form-group">
                    <label class="fw-500">User Type</label>
                    <select [(ngModel)]="userType" class="form-select" name="userType" style="border-radius: 1px">
                      <option value="1">All</option>
                      <option value="2">Pro User</option>
                      <option value="3">Free User</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 pl-0">
                <div class="row">
                  <div class="sub-heading" class="fw-500">Date Range</div>
                  <div class="col-xl-6 col-lg-6 col-md-6 pl-0">
                    <div class="date -start">
                      <div class="form-group">
                        <input type="text" [(ngModel)]="start_date" class="form-control" bsDatepicker
                          [ngModelOptions]="{ standalone: true }" [bsConfig]="bsConfig" name="start_date"
                          placeholder="Start Date" />
                        <i class="far fa-calendar-alt"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 pl-0">
                    <div class="date -end">
                      <div class="form-group">
                        <input type="text" [(ngModel)]="end_date" class="form-control" bsDatepicker
                          [ngModelOptions]="{ standalone: true }" [bsConfig]="bsConfig" name="end_date"
                          placeholder="End Date" />
                        <i class="far fa-calendar-alt"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="model-footer text-right mt-4">
                <button class="btn btn-success"
                  (click)="this.filter_apply = true;this.offset = 0;show_filters_drop = false; recentChat()">
                  Apply Filters
                </button>
              </div>
            </div>

            <div *ngIf="recentchatData && recentchatData.length > 0 ;else noChatList " class=" left1">
              <div class="d-flex justify-content-between p-3" *ngFor="let recentData of recentchatData;">
                <div>
                  <div class="image d-flex gap-3" style="position: relative;">
                    <!-- <img src="assets/images/chatbot/chat-profile-avtar.svg" (click)="recentStats(recentData,2)" style="cursor: pointer;" /> -->
                    <div class="avatar" (click)="recentStats(recentData,2)">
                      <span id="initials">{{ getInitials(recentData.name) }}</span>
                    </div>
                    <div class="ml-3">
                      <span class="mb-2" style="cursor: pointer;">
                        <span class="user--name" style="font-size: 14px; color: #181818; font-weight: 500;"
                          (click)="chat_type !== 5 && redirectV2(recentData.user_id,1)"> {{ recentData.name ?
                          recentData.name : "Recuvery User" }}{{
                          recentData.user_id && '(' +recentData.user_id + ')'}}</span>
                      </span>
                      <span class="d-flex mt-1 " style="gap:12px;">
                        <i class="fa fa-info info-tooltip mr-1" [tooltip]="recentData.note"></i>
                        <p class="desc" style="max-width: 80%;"> {{ recentData.note ? recentData.note : '*New message'
                          }}</p>
                        <span class="unread-message" *ngIf="recentData.new_msg_count > 0"></span>
                      </span>
                      <span class="user__id open-ticket-btn" (click)="redirectV2(recentData.req_id,2)"
                        style="cursor: pointer;">Ticket</span>
                      <span class="user__id open-chat-btn" (click)="recentStats(recentData,2)" style="cursor: pointer;">Open
                        Chat</span>
                    </div>
                  </div>
                </div>
                <div>
                  <p class="last_msg_time fs-13 fw-400"> {{ recentData.admin_last_msg_time }}</p>
                </div>
              </div>
            </div>
            <ng-template #noChatList>
              <p class="no-chat mt-5">No Chat List Found</p>
            </ng-template>
          </div>
        </div>

        <div class="border-right p-0 teammates_div " *ngIf="chat_type == 4">
          <h4>Active Teammates</h4>
          <div class="search_div my-3">
            <div class="input">
              <img src="assets/images/search-Icon.png" alt="secrch">
              <input type="text" placeholder="Search" [(ngModel)]="search_admin" (keyup.enter)="recentChat()" />
              <i class="fa fa-close" *ngIf="search_admin != ''" (click)="search_admin = ''; recentChat()"></i>
            </div>
          </div>
          <div class="image d-flex name-card" *ngFor="let dt of unreadData && unreadData.teammates"
            (click)="getAdminTicketList(dt);">
            <div class="d-flex align-items-center" style="gap: 10px;">
              <div class="avatar">
                <span id="initials">{{ getInitials(dt.admin_name) }}</span>
              </div>
              <span class="user_name" style="cursor: pointer;"> {{ dt.admin_name }}</span>
            </div>
            <div>
              <span class="count">{{dt.tickets_count}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>